import LanguagePack from "../../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import AbstractPdfSection from "../../../../../../lib/html5-software-library/src/ranj/pdf/sections/AbstractPdfSection";
import PersonalReportConfig from "../../model/PersonalReportConfig";
import PersonalReportModel from "../../model/PersonalReportModel";

export default class PerformanceSection extends AbstractPdfSection {
    /**
     * @constructor
     * @param {PersonalReportConfig} pdfConfig 
     * @param {LanguagePack} languagePack
     * @param {PersonalReportModel} personalReportModel
     */
    constructor(pdfConfig, languagePack, personalReportModel) {
        super(pdfConfig.pageWidth);

        this._pdfConfig = pdfConfig;
        this._languagePack = languagePack;
        this._personalReportModel = personalReportModel;
    }

    async loadData() {

    }

    initialize() {
        super.initialize();

        const title = this._languagePack.getText('personalReport.performance.title');
        this.addText(title, this._pdfConfig.getValue("elements.general.h3"));
        this.addText(this._personalReportModel.performance, this._pdfConfig.getValue("elements.general.div"));

        this.addPageBreak(false);
    }
}